import { useState } from "react";
import { auth } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

export default function Socios() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [usuario, setUsuario] = useState(null);
  const [mensajeError, setMensajeError] = useState("");

  const registrar = async () => {
    setMensajeError("");
    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      setUsuario(userCred.user);
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setMensajeError("Este correo ya está registrado.");
      } else {
        setMensajeError(error.message);
      }
    }
  };

  const ingresar = async () => {
    setMensajeError("");
    try {
      const userCred = await signInWithEmailAndPassword(auth, email, password);
      setUsuario(userCred.user);
    } catch (error) {
      if (error.code === "auth/wrong-password") {
        setMensajeError("Contraseña incorrecta.");
      } else if (error.code === "auth/user-not-found") {
        setMensajeError("No existe una cuenta con este correo.");
      } else {
        setMensajeError(error.message);
      }
    }
  };

  const salir = async () => {
    await signOut(auth);
    setUsuario(null);
  };

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <div className="max-w-6xl mx-auto">
        {/* Encabezado */}
        <div className="bg-gradient-to-r from-blue-700 to-blue-500 text-white px-6 py-4 rounded-t-xl shadow">
          <div className="flex items-center justify-between">
            <h2 className="text-3xl font-extrabold uppercase">👤 Socios</h2>
            {usuario && (
              <button
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded shadow"
                onClick={salir}
              >
                Cerrar sesión
              </button>
            )}
          </div>
        </div>

        <div className="bg-white p-6 rounded-b-xl shadow">
          {usuario ? (
            <>
              <p className="text-gray-700 mb-6">
                ¡Bienvenido, <strong>{usuario.email}</strong>!
              </p>

              <div className="grid md:grid-cols-2 gap-6">
                {[
                  {
                    titulo: "📸 Galería de Partidos",
                    descripcion: "Revive los mejores momentos de Quimsa.",
                    href: "/galeria",
                    boton: "Ir ahora",
                  },
                  {
  titulo: "❤️ Nuestros Heroes",
  descripcion: "Apoyarlos Siempre Quimsa",
  href: "/diadelpadre",
  boton: "Generar imagen",
},

                  {
                    titulo: "💬 Comunidad en Discord",
                    descripcion: "Unite a nuestra comunidad de hinchas.",
                    href: "https://discord.gg/PtAGJpHbt7",
                    boton: "Unirme",
                  },
                  {
                    titulo: "🎶 Playlist Quimsa",
                    descripcion: "Agregá canciones para la previa y el entretiempo.",
                    href: "https://open.spotify.com/playlist/1xgIR936KuzfjTlqb2mGfX?si=JqJkaJk9S46DBpp9vcx5Vg&pt=b6c787e80d678d3e5a6613184d60293c",
                    boton: "Escuchar",
                  },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="flex flex-col bg-white border border-gray-200 rounded-xl shadow-md p-4"
                  >
                    <h3 className="text-xl font-bold text-blue-700 mb-1">{item.titulo}</h3>
                    <p className="text-sm text-gray-700">{item.descripcion}</p>
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-3 inline-block bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 transition"
                    >
                      {item.boton}
                    </a>
                  </div>
                ))}

                <div className="flex flex-col justify-between bg-yellow-50 border border-yellow-200 rounded-xl shadow-md md:col-span-2 p-4">
                  <h3 className="text-xl font-bold text-yellow-600 mb-2">🧩 Fusionaditos Kids</h3>
                  <p className="text-sm text-gray-700 mb-3">
                    Actividades infantiles para los pequeños fans de Quimsa 💙❤️
                  </p>
                  <div className="grid sm:grid-cols-3 gap-3">
                    <a
                      href="/descargas/sopa.pdf"
                      download
                      className="bg-pink-400 hover:bg-pink-500 text-white px-4 py-2 rounded-full text-center text-sm transition"
                    >
                      📝 Sopa de Letras
                    </a>
                    <a
                      href="/descargas/dibujo-escudo.pdf"
                      download
                      className="bg-indigo-400 hover:bg-indigo-500 text-white px-4 py-2 rounded-full text-center text-sm transition"
                    >
                      🎨 Escudo de Quimsa
                    </a>
                    <a
                      href="/descargas/kushi-dibujo.pdf"
                      download
                      className="bg-green-400 hover:bg-green-500 text-white px-4 py-2 rounded-full text-center text-sm transition"
                    >
                      🐯 Kushi para colorear
                    </a>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {mensajeError && (
                <p className="text-red-500 text-sm mb-4">{mensajeError}</p>
              )}

              {/* Cuadros explicativos */}
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 rounded">
                  <p className="font-semibold">¿Primera vez?</p>
                  <p>Completá tus datos y presioná <strong>Registrarse</strong>.</p>
                </div>
                <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded">
                  <p className="font-semibold">¿Ya te registraste?</p>
                  <p>Ingresá tus datos y hacé clic en <strong>Iniciar sesión</strong>.</p>
                </div>
              </div>

              {/* Formulario */}
              <input
                className="border border-gray-300 p-2 w-full mb-2 rounded"
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                className="border border-gray-300 p-2 w-full mb-4 rounded"
                type="password"
                placeholder="Contraseña"
                onChange={(e) => setPassword(e.target.value)}
              />
              <div className="flex justify-between">
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700 transition"
                  onClick={registrar}
                >
                  Registrarse
                </button>
                <button
                  className="bg-green-600 text-white px-4 py-2 rounded shadow hover:bg-green-700 transition"
                  onClick={ingresar}
                >
                  Iniciar sesión
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
